<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'GPSウォーク／ランイベント'">
          <list-item :spanText="'Q. '" :text="'「スタート」をタップしても反応しない'" :urlName="'Help38'"></list-item>
          <list-item :spanText="'Q. '" :text="'ホームの距離値が反映されない理由は？'" :urlName="'Help15'"></list-item>
          <list-item :spanText="'Q. '" :text="'「ウォーク/ラン」で計測したデータの一部のみ反映される理由は？'" :urlName="'Help16'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory22.vue